<mat-toolbar class="topbar">
  <!-- Desktop Menu -->
  @if(showToggle) {
  <button
    mat-icon-button
    (click)="toggleCollapsed.emit()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <!-- Mobile Menu -->
  @if(!showToggle) {
  <button
    mat-icon-button
    (click)="toggleMobileNav.emit()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <span class="flex-1-auto"></span>

  <!-- Mobile Menu -->
  <button
    mat-icon-button
    (click)="toggleMobileFilterNav.emit()"
    class="d-flex d-lg-none justify-content-center"
  >
    <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- Profile Dropdown -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="User profile"
    class="profile-trigger"
  >
    <img
      *ngIf="userImageUrl as img"
      [src]="img"
      class="rounded-circle object-cover profile-avatar-img"
      width="35"
      height="35"
      alt=""
    />
    <span *ngIf="!userImageUrl" class="profile-avatar-initials profile-avatar-initials--sm">
      {{ getUserInitials() }}
    </span>
  </button>
  <mat-menu #profilemenu="matMenu" class="profile-dd" xPosition="before">
    <div class="profile-dd__panel">
      <div class="profile-dd__user">
        <img
          *ngIf="userImageUrl as img"
          [src]="img"
          class="rounded-circle object-cover profile-avatar-img"
          width="40"
          height="40"
          alt=""
        />
        <span *ngIf="!userImageUrl" class="profile-avatar-initials profile-avatar-initials--md">
          {{ getUserInitials() }}
        </span>
        <div class="profile-dd__meta">
          <strong>{{ getUserDisplayName() }}</strong>
          <span *ngIf="getUserRole()">{{ getUserRole() }}</span>
          <span *ngIf="user?.email" class="profile-dd__email">{{ user.email }}</span>
        </div>
      </div>

      <div class="profile-dd__divider"></div>

      @for(profile of profiledd; track profile.title) {
      <a class="profile-dd__link" [routerLink]="[profile.link]">
        <i-tabler name="user" class="icon-18"></i-tabler>
        <span>{{ profile.title }}</span>
      </a>
      }

      <button type="button" class="profile-dd__logout" (click)="logout()">
        <i-tabler name="logout" class="icon-18"></i-tabler>
        Logout
      </button>
    </div>
  </mat-menu>
</mat-toolbar>
